export enum ROUTE_PATHS {
  USERS_LIST = "users",
  ACTIVE_TAGS = "active-tags",
  VIDEO_PLAYER = "video/:id",
  PHOTO_VIEW = "image/:id",
  GALLERY = "gallery/",

  LOGIN = "login",
  FORGOT_PASSWORD = "forgot-password",
  SET_PASSWORD = "set-password/:token",

  USER_SETTINGS = "user/*",
  USER_PROFILE = "profile",
  USER_PASSWORD = "password",
}
